















import { Component, Prop, Vue } from 'vue-property-decorator'
import Color from 'color'
import { Referral } from '@/api/model/referral'

@Component
export default class ReferralPhaseWithReasonLabel extends Vue {
    @Prop({ required: true }) readonly referral!: Referral

    get classAttribute(): string[] {
        return [
            'text-xs',
            'rounded',
            'py-1',
            'px-3',
            'flex',
            'flex-wrap',
            'justify-center',
            'items-center',
            'w-full',
            'h-full',
        ]
    }

    get styleAttribute() {
        return {
            backgroundColor: this.backgroundColor,
            color: this.foregroundColor,
        }
    }

    get backgroundColor(): Color {
        return Color(this.referral.phase.color)
    }

    get foregroundColor(): Color {
        return Color('white').alpha(0.9)
    }

    get reasonName(): string|null {
        return this.referral.newStatusReason ? this.referral.newStatusReason.name : null
    }

    get phaseName(): string {
        return this.referral.phase ? this.referral.phase.name : null
    }
}
